'use client';
import { FaWhatsapp } from 'react-icons/fa';
import styles from './FloatingWhatsApp.module.css';

export function FloatingWhatsApp() {
  return (
    <div className={styles.floatingWrapper}>
      <div className={styles.tooltip}>
        Precisa de ajuda? 🟢
      </div>
      
      <a
        // Coloquei uma mensagem automática para facilitar a vida do lead
        href="https://api.whatsapp.com/send/?phone=5511983493522&text=Ola,%20estou%20no%20site%20e%20quero%20falar%20com%20um%20consultor%20do%20Aesir%20ERP!"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.whatsappBtn}
        aria-label="Fale conosco pelo WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}